import { useEffect, useState } from 'react';

import { isEmpty } from 'lodash';
import { useAccountSelector } from 'src/hooks';
import { MFormSection } from 'src/lib';

import { PhysicalAddressForm } from './PhysicalAddressForm';
import { PhysicalAddressView } from './PhysicalAddressView';

export const AccountHolderPhysicalAddressSection = () => {
  const [isEditable, setIsEditable] = useState<boolean>(false);
  const [isEditMode, setIsEditMode] = useState<boolean>(false);

  const { account } = useAccountSelector();

  const onEdit = () => {
    setIsEditMode(true);
  };

  const onCancel = () => {
    setIsEditMode(false);
  };

  const isPhysicalAddressAlreadySaved = () => !isEmpty(account?.primaryAccountHolder?.physicalAddress);

  useEffect(() => {
    if (isPhysicalAddressAlreadySaved()) {
      setIsEditable(true);
    }
  }, [account?.primaryAccountHolder?.physicalAddress]);

  return (
    <MFormSection
      title='Physical Address'
      onEdit={onEdit}
      disabled={Boolean(account?.lastFailedLinkAttemptError)}
      isEditable={isEditable}
      isEditMode={isEditMode}
      testId={`physical-address`}>
      {isPhysicalAddressAlreadySaved() && !isEditMode ? (
        <PhysicalAddressView accountHolder={account?.primaryAccountHolder} testId={'primary'} />
      ) : (
        <PhysicalAddressForm
          accountHolder={account?.primaryAccountHolder}
          accountUuid={account?.id}
          isPrimary
          onCancel={onCancel}
        />
      )}
    </MFormSection>
  );
};
